import * as Yup from 'yup';
import CrudFormLayout from '../../../Layout/CrudFormLayout';
import VisaForm from './VisaForm';
import { formDataConverterNew } from '../../../../utils/necessaryFunctions';

const VisaFormContainer = ({ apiHandler, editData }) => {
    const initialValues = {
        name: editData?.name || '',
        image: editData?.image || '',
        destination_id: editData?.destination_id || '',
        visa_type: editData?.visa_type_id || '',
        max_stays: editData?.max_stays || '',
        validity: editData?.validity || '',
        visa_mode: editData?.visa_mode || '',
        price: editData?.price || '',
        package_discount: editData?.package_discount || '',
        success_count: editData?.success_count || '',
        description: editData?.description || '',
        required_documents: editData?.required_documents || '',
        // visa_faq: editData?.visa_faq || '',
        status: editData ? editData?.status : 1,
        // facility: editData?.facility?.map((item) => ({
        //     value: item.value,
        // })) || [{ value: '' }],
        // included: editData?.includes?.map((item) => ({
        //     value: item.value,
        // })) || [{ value: '' }],
        // excluded: editData?.excludes?.map((item) => ({
        //     value: item.value,
        // })) || [{ value: '' }],
        // highlights_bulletpoints: editData?.points?.map((item) => ({
        //     value: item.value,
        // })) || [{ value: '' }],
        // itinerary: editData?.itineraries?.map((item) => ({
        //     // day: item.day,
        //     value: item.value,
        // })) || [{ value: '' }],
        // features: editData?.package_features?.map((item) => ({
        //     name: item.name,
        //     value: item.value,
        // })) || [{ name: '', value: '' }],
    };
    //! Active validationSchema testing
    // const validationSchema = Yup.object().shape({
    //     name: Yup.string().required('Name is required'),

    //     price: Yup.number()
    //         .typeError('Price must be a number')
    //         .required('Price is required')
    //         .positive('Price must be a positive number'),
    //     tourType: Yup.string().required('Tour Type ID is required'),

    //     duration: Yup.number()
    //         .typeError('Duration must be a number')
    //         .required('Duration is required'),

    //     package_discount: Yup.number()
    //         .typeError('Discount must be a number')
    //         .min(0, 'Discount cannot be negative')
    //         .max(100, 'Discount cannot be more than 100')
    //         .nullable(),

    //     status: Yup.number().oneOf([0, 1], 'Status must be either 0 or 1'),

    //     included: Yup.array().of(
    //         Yup.object().shape({
    //             value: Yup.string().required('Included item value is required'),
    //         })
    //     ),

    //     excluded: Yup.array().of(
    //         Yup.object().shape({
    //             value: Yup.string().required('Excluded item value is required'),
    //         })
    //     ),

    //     highlights_bulletpoints: Yup.array().of(
    //         Yup.object().shape({
    //             value: Yup.string().required('Highlight bullet point is required'),
    //         })
    //     ),

    //     itinerary: Yup.array().of(
    //         Yup.object().shape({
    //             value: Yup.string().required('Itinerary item is required'),
    //         })
    //     ),

    //     features: Yup.array().of(
    //         Yup.object().shape({
    //             name: Yup.string().required('Feature name is required'),
    //             value: Yup.string().required('Feature value is required'),
    //         })
    //     ),
    // });

    const validationSchema = Yup.object().shape({
        //     // name: Yup.string().required('Name is required'),
        //     // price: Yup.number()
        //     //     .typeError('Price must be a number')
        //     //     .required('Price is required')
        //     //     .positive('Price must be a positive number'),
        //     // tourType: Yup.string().required('Tour Type ID is required'),
        //     // duration: Yup.string().required('Duration ID is required'),
        //     // package_discount: Yup.number()
        //     //     .typeError('Discount must be a number')
        //     //     .min(0, 'Discount cannot be negative')
        //     //     .max(100, 'Discount cannot be more than 100')
        //     //     .nullable(),
        //     // status: Yup.number().oneOf([0, 1], 'Status must be either 0 or 1'),
        //     // features: Yup.array().of(
        //     //     Yup.object()
        //     //         .shape({
        //     //             name: Yup.string().required('Feature name is required'),
        //     //             value: Yup.string(),
        //     //         })
        //     //         .optional()
        //     // ),
    });

    const formHandler = (values) => {
        console.log('Before apiHandler Form Values: ', values);
        // return null;
        const formData = formDataConverterNew(values);
        console.log('After formData Convert formData: ', values);
        if (apiHandler) {
            return apiHandler(formData);
            // return apiHandler(values);
        }
        return null;
    };

    return (
        <div>
            <CrudFormLayout
                initialValues={initialValues}
                buttonCenter
                apiHandler={formHandler}
                validationSchema={validationSchema}
            >
                <VisaForm />
            </CrudFormLayout>
        </div>
    );
};

export default VisaFormContainer;
